<script setup>
import {
  computed,
  ref,
  reactive,
  onMounted
} from 'vue'

const video = ref(null)
const props = defineProps({
  images: {
    type: Array,
    default: () => []
  },
  movie: {
    type: Object,
    default: () => {}
  },
  height: {
    type: String,
    default: '80px'
  }
})
const state = reactive({
  minutes: 0,
  seconds: 0,
})

const imageNumber = computed(() => {
  return props.images.length - 1
})

onMounted(() => {
  if (!props.movie) return

  video.value.oncanplay = () => {
    const maxTime = Math.floor(video.value.duration)
    state.minutes = ('00' + Math.floor(maxTime / 60)).slice(-2)
    state.seconds = ('00' + Math.floor(maxTime % 60)).slice(-2)
  }
})
</script>

<template>
  <div>
    <div v-if="props.images.length" class="thumbnail" :style="{height: props.height}">
      <img
        :src="props.images[0].url"
        alt=""
      >
      <p v-if="imageNumber" class="number">+{{ imageNumber }}</p>
    </div>
    <div v-else-if="props.movie" class="thumbnail" :style="{height: props.height}">
      <video ref="video" :src="props.movie.url" muted />
      <div class="time">{{ `${state.minutes}:${state.seconds}` }}</div>
    </div>
    <div v-else class="thumbnail noContent" :style="{height: props.height}">
      <p class="noImage">NO IMAGE</p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '../../../../../../stylesheets/biz_spa/foundation/_var.scss';

.thumbnail {
  position: relative;
  border: 1px solid #E4E7EB;
  border-radius: 4px;
  &.noContent {
    display: flex;
    justify-content: center;
    align-items: center;

    @media screen and (max-width: 768px) {
      display: none;
    }
  }

  img {
    display: block;
    object-fit: contain;
    width: 100%;
    height: 100%;
  }

  video {
    width: 100%;
    height: 100%;
  }

  .noImage {
    color: #979797;
    letter-spacing: 3px;
  }

  .number {
    position: absolute;
    top: 5px;
    right: 5px;
    color: white;
    font-weight: bold;
    font-size: 0.8em;
    border-radius: 100vh;
    background-color: rgba(0,0,0,0.7);
    padding: 0 6px;
  }

  .time {
    position: absolute;
    bottom: 0;
    right: 0;
    color: white;
    font-size: 0.8em;
    background-color: rgba(0,0,0,0.7);
    padding: 0 6px;
  }
}
</style>
